import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StyleLoaderService {
  loadStyles(): Promise<void> {
    return new Promise<void>(resolve => {
      const style = document.createElement('style');
      //   linkElement.rel = 'stylesheet';
      style.innerHTML = require('./plugin-styles.scss');
      document.head.appendChild(style);
      style.onload = () => {
        resolve();
      };
    });
  }
}
